/**
 * Maps a dealer status key to a Badge variant.
 *
 * Shared between DealerDataTable (list view) and DealerDetail (detail/header)
 * so the list and detail badges agree for every catalogue status, including
 * the additional statuses introduced by #327 (`active_for_sales`,
 * `active_for_invoicing`, `pending`).
 */
export type StatusVariant = 'success' | 'warning' | 'error' | 'outline';

export function statusVariant(statusKey?: string): StatusVariant {
  if (statusKey === 'active' || statusKey?.startsWith('active_')) return 'success';
  if (statusKey === 'pending') return 'warning';
  if (statusKey === 'inactive') return 'error';
  return 'outline';
}
